import {useCallback} from 'react';

import {copyToClipboardAsync} from '../../../libs/shared/helpers/src/browser/domHelpers';
import {useLayer} from '../../../libs/shared/ui/src/components/layers/layerContext';

/** Provide a method to copy text in the current window's clipboard. */
export function useClipboard() {
  const {window} = useLayer();
  const copy = useCallback((text: string) => copyToClipboardAsync(window, text), [window]);
  return {copy};
}
